import type { NextPage } from 'next';

import { useFeatureFlag } from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

import { NotFoundContainer } from 'routes/errors';

import { PackagesContainer } from '../routes/packages/Packages.container';

const Packages: NextPage = () => {
  const { isEnabled: isPackagesPageEnabled } = useFeatureFlag(
    FEATURE_FLAGS.PACKAGES_PAGE,
  );

  if (!isPackagesPageEnabled) {
    return <NotFoundContainer />;
  }

  return <PackagesContainer />;
};

Packages.getInitialProps = function () {
  return {
    metadata: {
      title: 'Packages',
    },
  };
};

export default Packages;
